// colors.ts
export const ColorScheme = {
    // Base Colors
    white: '#FFFFFF',
    obsidian: '#333333',
    onyx: '#000000',
  
    // Semantic Colors
    black: '#000000',
    grey: '#808080',
    blue: '#0000FF',
    green: '#008000',
    orange: '#FFA500',
    pink: '#FFC0CB',
    olive: '#808000',
    purple: '#800080',
    violet: '#EE82EE',
    red: '#FF0000',
    teal: '#008080',
    yellow: '#FFFF00',
  
    // Derived Colors
    lightBlack: '#A9A9A9',
    lightBlue: '#ADD8E6',
    lightGreen: '#90EE90',
    lightOrange: '#FFDAB9',
    lightPink: '#FFB6C1',
    lightOlive: '#C7C763',
    lightPurple: '#D8BFD8',
    lightViolet: '#E6E6FA',
    lightRed: '#FF6961',
    lightTeal: '#5F9EA0',
    lightYellow: '#FFFFE0',
    blueBackground: '#D6EAF8',
    greenBackground: '#D4EFDF',
    orangeBackground: '#FDEBD0',
    pinkBackground: '#FADBD8',
    oliveBackground: '#F9E79F',
    purpleBackground: '#EBDEF0',
    violetBackground: '#E8DAEF',
    redBackground: '#F5B7B1',
    tealBackground: '#D5F5E3',
    yellowBackground: '#FCF3CF',
    darkBlue: '#00008B',
    darkGreen: '#006400',
    darkOrange: '#FF8C00',
    darkPink: '#C71585',
    darkOlive: '#556B2F',
    darkPurple: '#4B0082',
    darkViolet: '#9400D3',
    darkRed: '#8B0000',
    darkTeal: '#008080',
    darkYellow: '#FFD700',
    gray: '#D3D3D3',
    offWhite: '#FAF9F6',
    darkWhite: '#F5F5F5',
    lightGrey: '#D3D3D3',
    darkGrey: '#A9A9A9',
    ltScreen85: 'rgba(255, 255, 255, 0.85)',
    dkScreen85: 'rgba(0, 0, 0, 0.85)',
    ltScreen50: 'rgba(255, 255, 255, 0.5)',
    dkScreen50: 'rgba(0, 0, 0, 0.5)',
    ltScreen25: 'rgba(255, 255, 255, 0.25)',
    dkScreen25: 'rgba(0, 0, 0, 0.25)',
    ltScreen10: 'rgba(255, 255, 255, 0.1)',
    dkScreen10: 'rgba(0, 0, 0, 0.1)',
    clear: 'rgba(255, 255, 255, 0)',
    sable: '#D1D1D1',
    dover: '#BCBEC0',
    ashen: '#9D9D9D',
    slate: '#373737',
    lunar: '#F7F7F7',
    feather: '#EEEEEE',
  };